import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { homeFaqData } from '../data/homeFaq';

const FAQAccordion = ({
  items = homeFaqData,
  subtitle = 'מצאו תשובות לשאלות נפוצות בנוגע לחדלות פירעון והוצאה לפועל.',
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [openColumn, setOpenColumn] = useState(null);

  const toggleAccordion = (index, column) => {
    if (openIndex === index && openColumn === column) {
      setOpenIndex(null);
      setOpenColumn(null);
    } else {
      setOpenIndex(index);
      setOpenColumn(column);
    }
  };

  const isOpen = (index, column) => openIndex === index && openColumn === column;

  const renderItem = (item, index, column) => {
    const expanded = isOpen(index, column);

    return (
      <div
        key={`${column}-${index}`}
        className="h-full rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden flex flex-col"
      >
        <button
          type="button"
          onClick={() => toggleAccordion(index, column)}
          className={`flex justify-between items-center gap-4 w-full px-6 py-4 text-right font-medium text-gray-800 hover:bg-gray-50 transition-colors duration-300 ${
            expanded ? '' : 'flex-1'
          }`}
        >
          <span className="text-base leading-snug">{item.question}</span>
          <motion.div
            initial={false}
            animate={{ rotate: expanded ? 180 : 0 }}
            transition={{ duration: 0.3 }}
            className="flex-shrink-0"
          >
            <ChevronDown className="w-6 h-6 text-gray-500" />
          </motion.div>
        </button>
        <AnimatePresence>
          {expanded && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              className="px-6 pb-4"
            >
              <p className="text-sm text-gray-600 border-t border-gray-200 pt-4 leading-relaxed">
                {item.answer}
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    );
  };

  return (
    <div className="w-full py-24 bg-white" dir="rtl">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 text-center mb-12">
          שאלות נפוצות
        </h2>
        {subtitle && (
          <p className="text-lg text-gray-600 text-center mb-12">{subtitle}</p>
        )}

        <div className="hidden md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-3 md:items-stretch">
          {items.map((item, index) => (
            <div key={`desktop-${index}`} className="h-full">
              {renderItem(item, index, 'desktop')}
            </div>
          ))}
        </div>

        <div className="md:hidden space-y-3">
          {items.map((item, index) => renderItem(item, index, 'mobile'))}
        </div>
      </div>
    </div>
  );
};

export default FAQAccordion;
